// src/features/supplierPedidos/api.ts
import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type { SupplierPedidosSummary } from "./types";

/**
 * Fetches the supplier pedidos summary for the given date range.
 * from and to must be YYYY-MM-DD strings in the São Paulo timezone (use periodToSaoPauloRange).
 */
export function getSupplierPedidos(
  from: string,
  to: string,
): Promise<SupplierPedidosSummary> {
  const qs = new URLSearchParams({ from, to });
  return apiFetch(`${ENDPOINTS.supplierPedidos.summary}?${qs}`);
}
